export const crmTableColumns = [
  {
    title: 'Имя',
    dataIndex: 'nick_name',
    sorter: true,
  },
  {
    title: 'Логин',
    dataIndex: 'login',
    sorter: true,
  },
  {
    title: 'Звонков',
    dataIndex: 'daycalls',
    sorter: true,
    width: '15%',
  },
]
